let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8nqTj")).then(() => parcelRequire('9C0G5'));